export default "__VITE_ASSET__DcauB7HA__"